import React from 'react'
import { Plus, Users } from 'lucide-react'
import { FILL_GRADIENT } from '../../constants/gradients'

interface CreateTeamCardProps {
  onCreateTeam: () => void
}

export const CreateTeamCard: React.FC<CreateTeamCardProps> = ({
  onCreateTeam
}) => {
  return (
    <div className="bg-white dark:bg-dark-surface border-2 border-dashed border-gray-200 dark:border-dark-border rounded-xl p-8 text-center hover:border-gray-300 dark:hover:border-gray-600 transition-colors">
      <div className="max-w-md mx-auto">
        {/* Icon */}
        <div 
          className="w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-5"
          style={{ background: 'linear-gradient(135deg, #FCB902 0%, #FF00CF 100%)' }}
        >
          <Users className="w-10 h-10 text-white" />
        </div>
        
        {/* Title */}
        <h3 className="text-2xl font-semibold text-gray-900 dark:text-dark-text mb-3">
          Create Your First Team
        </h3>
        
        {/* Description */}
        <p className="text-gray-500 dark:text-dark-text-muted mb-8">
          Start collaborating with others by creating a team. Invite members, share games, and work together seamlessly.
        </p>
        
        {/* Action Button */}
        <button
          onClick={onCreateTeam}
          className="px-8 py-3 text-base font-semibold text-white rounded-lg transition-all duration-200 hover:shadow-lg hover:scale-105 active:scale-95 flex items-center gap-2 mx-auto"
          style={{ background: FILL_GRADIENT }}
        >
          <Plus className="w-5 h-5" />
          Create Team
        </button>
      </div>
    </div>
  )
} 